import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminClients_municipalityIdData_importBatches_idUndo = z.any()
export type TagsPostAdminClients_municipalityIdData_importBatches_idUndo = z.infer<typeof tagsPostAdminClients_municipalityIdData_importBatches_idUndo>

export const paramsPostAdminClients_municipalityIdData_importBatches_idUndo = z.object({ "municipalityId": z.string().uuid(), "id": z.string().uuid() })
export type ParamsPostAdminClients_municipalityIdData_importBatches_idUndo = z.infer<typeof paramsPostAdminClients_municipalityIdData_importBatches_idUndo>

export const bodyPostAdminClients_municipalityIdData_importBatches_idUndo = z.object({ "undoToken": z.string().min(64).max(64).optional() })
export type BodyPostAdminClients_municipalityIdData_importBatches_idUndo = z.infer<typeof bodyPostAdminClients_municipalityIdData_importBatches_idUndo>

export const responsePostAdminClients_municipalityIdData_importBatches_idUndo = z.object({ "payload": z.object({ "batchId": z.string(), "canUndo": z.boolean(), "undone": z.boolean(), "undoToken": z.string(), "blockers": z.array(z.string()), "records": z.number().int() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminClients_municipalityIdData_importBatches_idUndo = z.infer<typeof responsePostAdminClients_municipalityIdData_importBatches_idUndo>

interface IPostAdminClients_municipalityIdData_importBatches_idUndo extends BaseMethodType {
  tags: TagsPostAdminClients_municipalityIdData_importBatches_idUndo,
  params: ParamsPostAdminClients_municipalityIdData_importBatches_idUndo,
  body: BodyPostAdminClients_municipalityIdData_importBatches_idUndo,
  response: ResponsePostAdminClients_municipalityIdData_importBatches_idUndo
}
export const URL = '/admin/clients/:municipalityId/data-import/batches/:id/undo'
export const validation = {
  post: {
    tags: tagsPostAdminClients_municipalityIdData_importBatches_idUndo,
    params: paramsPostAdminClients_municipalityIdData_importBatches_idUndo,
    body: bodyPostAdminClients_municipalityIdData_importBatches_idUndo,
    response: responsePostAdminClients_municipalityIdData_importBatches_idUndo
  }
}
export interface AdminClients_municipalityIdData_importBatches_idUndo extends BaseRouteType {
  post: IPostAdminClients_municipalityIdData_importBatches_idUndo
}